import { FormControl, FormLabel, FormHelperText, Input } from '@chakra-ui/react';
import { useCampaignUI } from './ui';
export function DateField({ label, ariaLabel, help, value, onChange, minDate, maxDate, isDisabled, ...props }) {
 const ui = useCampaignUI();
 return <FormControl {...props}>{label && <FormLabel fontSize='sm' color={ui.textSecondary}>{label}</FormLabel>}
  <Input type='date' value={value ?? ''} onChange={(event) => onChange?.(event.target.value)} min={minDate} max={maxDate}
   aria-label={ariaLabel ?? label ?? 'Date'} isDisabled={isDisabled} sx={{ colorScheme: ui.mode }} bg={ui.inputBg} borderColor={ui.border} color={ui.textPrimary} size='sm'  />
  {help && <FormHelperText color={ui.textMuted}>{help}</FormHelperText>}
 </FormControl>;
}
